import { instance } from './ApiRequest';
import {
    ROOT_PATH, GET_PORTAL_CONFIG, ADMIN_DASHBOARD, UPDATE_PORTAL_CONFIG, GET_ALL_POSTS, ADD_UPDATE_POSTS,
    DELETE_POST, GET_ALL_CATEGORY_ADMIN, ADD_UPDATE_CATEGORY, DELETE_CATEGORY, GET_ALL_UNIVERSITIES, ADD_UPDATE_UNIVERSITY, DELETE_UNIVERSITY,
    GET_ALL_DEGAREES, ADD_UPDATE_QUALIFICATION, DELETE_QUALIFICATION, GET_ALL_CENTER, ADD_UPDATE_CENTER, DELETE_CENTER, GET_ALL_CLASSROOMS,
    ADD_UPDATE_CLASSROOMS, DELETE_CLASSROOM, GET_ALL_SPECIFICATIONS, ADD_UPDATE_SPECIFICATION, DELETE_SPECIFICATION, GET_CHALAN_BANK_DETAILS,
    ADD_CHALAN_BANK_DETAILS, GET_ALL_STUDENTS, GET_ALL_STUDENTS_FOR_REVIEW, UPDATE_STUDENT_DATA, READ_EXCEL, ADD_UPDATE_STUDENT_NOTIFICATION,
    DELETE_CHALAN_BANK_DETAILS, UPDATE_STUDENT_STATUS, EXPORT_ALL_STUDENTS, GET_ALL_STUDENTS_ATTENDANCE, EXPORT_ATTENDANCE_EXCEL, GET_ELIGIBLE_CANDIDATES,
    EXPORT_RESULT_EXCEL, UPDATE_STUDENT_BATCH, REMOVE_STUDENT_FROM_BATCH, GET_ALL_STUDENTS_BY_CENTER, GET_ALL_DISTRICT, GET_ALL_TALUKAS,
    UPDATE_STUDENT_ROLL_NUMBER, GET_ALL_STUDENTS_ROLL_NUMBER, REGENERATE_STUDENTS_ROLL_NUMBER, EXPORT_ALL_STUDENTS_BATCHES, EXPORT_ALL_STUDENTS_DATA,
    EXPORT_ALL_STUDENTS_BATCHES_EXCEL, EXPORT_ALL_STUDENTS_DATA_EXCEL, GET_ALL_RAZORPAY_TRANSACTIONS, REFUND_TRANSACTION, GET_CAPTCHA, GET_RESET_DATABASE,
    GET_ALL_STATES, GET_POST_CONFIGURATION_DATA, ADD_UPDATE_POST_CONFIGURATION, EXPORT_ALL_IMAGES_DATA, VALIDATE_LICENCE_KEY,
    IMPORT_STUDENT_RESULT,IMPORT_STUDENT_INTERVIEW_RESULT, GET_STUDENT_RESULT_BY_APPLICATION_ID,
    PREVIEW_INTERVIEW_SHORTLIST, CONFIRM_INTERVIEW_SHORTLIST, EXPORT_INTERVIEW_BLIND_DATA,
    IMPORT_FINAL_RESULT, PREVIEW_FINAL_RESULT, PUBLISH_FINAL_RESULT, GET_PUBLISHED_SELECTED_WAITING_ROLL_NUMBERS,
    GET_ALL_STUDENT_ANSWER_PAPER_LIST, Add_Or_Update_Student_Answer_Paper, DELETE_STUDENT_ANSWER_PAPER,
    SEND_BULK_SMS_FOR_HALL_TICKET_DOWNLOAD, SEND_BULK_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD, SEND_BULK_EMAIL_FOR_HALL_TICKET_DOWNLOAD, SEND_RETRY_EMAIL_FOR_HALL_TICKET_DOWNLOAD,
    GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_SMS,SEND_RETRY_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD,
    SEND_BULK_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD,GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_EMAIL,
    SEND_RETRY_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD,GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_SMS,SEND_BULK_SMS_FOR_VIEW_RESULT_SMS,SEND_BULK_EMAIL_FOR_VIEW_RESULT,


    SEND_RETRY_SMS_FOR_HALL_TICKET_DOWNLOAD, GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_EMAIL,GET_STUDENT_DATA_FOR_ADMIN, GET_STUDENT_RECEIPT_DATA_FOR_ADMIN,
    GET_STUDENT_DATA_FOR_ATTENDANCE,IMPORT_STUDENT_ATTENDANCE_DATA,GET_ALL_CENTER_LIST,GET_ALL_BATCH_CENTER_BY_NAME,GET_ALL_ATTENDANCE_DATA,DELETE_STUDENT_ATTENDANCE_DATA,
    GET_TOTAL_STUDENT_REGISTER_DATA,GET_DISTINCT_POST_BY_CENTER_AND_BATCH,

    GET_ALL_STUDENT_AKSHEP_DATA,DELETE_STUDENT_AKSHEP_DATA,ADD_UPDATE_STUDENT_AKSHEP_DATA,GET_STUDENT_AKSHEP_DATA,
    
    IMPORT_CENTER_BATCH_DATA,GET_ALL_CENTER_BATCH_LIST,DELETE_CENTER_BATCH_DATA,IMPORT_CENTER_BATCH_LAB_COUNT_DATA,DELETE_CENTER_BATCH_LAB_COUNT_DATA,GET_ALL_CENTER_BATCH_DATA_BY_CENTER,
    GET_DISTINCT_CENTER_FROM_BATCH_LAB_COUNT,GET_DISTINCT_EXAM_DATE_BY_CENTER_NAME,GET_ALL_CENTER_BATCH_LAB_COUNT_DATA_BY_CENTER_AND_DATE,EXPORT_CENTER_WISE_ATTENDANCE_DATA,

    IMPORT_STUDENT_INTERVIEW_TIME_DATA,GET_DISTINCT_POST_FROM_STUDENT_INTERVIEW_TIME_DATA,GET_ALL_STUDENT_INTERVIEW_TIME_DATA_BY_POST,DELETE_STUDENT_INTERVIEW_TIME_DATA,GET_STUDENT_INTERVIEW_TIME_DATE_BY_APPLICATION_ID,
    GENERATE_LICENSE_KEY,GET_PORTAL_CONFIG_WITHOUT_IMAGE,

    IMPORT_STUDENT_APPOINTMENT_DATA,GET_DISTINCT_POST_FROM_STUDENT_APPOINTMENT_DATA,GET_ALL_STUDENT_APPOINTMENT_DATA_BY_POST,DELETE_STUDENT_APPOINTMENT_DATA,GET_STUDENT_APPOINTMENT_DATA_BY_ROLE_NUMBER,

    GET_AADHAR_LOG_DATA_COUNT_BY_POST_AND_AADHAR_NUMBER,ADD_OR_UPDATE_STUDENT_AADHAR_LOG,
} from 'constants/constants';

let _AdminService = {
    async GetAdminDashboardData() {
        return await instance.get(ADMIN_DASHBOARD);
    },
    async GetPortalConfiguration() {
        return await instance.get(GET_PORTAL_CONFIG + "?portalConfigurationId=1");
    },
    async GetPortalConfigurationWithoutImage() {
        return await instance.get(GET_PORTAL_CONFIG_WITHOUT_IMAGE + "?portalConfigurationId=1");
    },
    async UpdatePortalConfiguration(body) {
        return await instance.post(UPDATE_PORTAL_CONFIG, body);
    },
    async GetAllPost() {
        return await instance.get(GET_ALL_POSTS);
    },
    async CreatePost(body) {
        return await instance.post(ADD_UPDATE_POSTS, body);
    },
    async DeletePost(postID) {
        return await instance.post(DELETE_POST + "?postId=" + postID);
    },
    async GetAllCategory() {
        return await instance.get(GET_ALL_CATEGORY_ADMIN);
    },
    async CreateCategory(body) {
        return await instance.post(ADD_UPDATE_CATEGORY, body);
    },
    async DeleteCategory(categoryID) {
        return await instance.post(DELETE_CATEGORY + "?categoryId=" + categoryID);
    },
    async GetAllUniversity() {
        return await instance.get(GET_ALL_UNIVERSITIES);
    },
    async CreateUniversity(body) {
        return await instance.post(ADD_UPDATE_UNIVERSITY, body);
    },
    async DeleteUniversity(categoryID) {
        return await instance.post(DELETE_UNIVERSITY + "?universityId=" + categoryID);
    },
    async GetAllDegree() {
        return await instance.get(GET_ALL_DEGAREES);
    },
    async CreateDegree(body) {
        return await instance.post(ADD_UPDATE_QUALIFICATION, body);
    },
    async DeleteDegree(DegreeId) {
        return await instance.post(DELETE_QUALIFICATION + "?qualificationId=" + DegreeId);
    },
    async GetAllCenter(postID) {
        return await instance.get(GET_ALL_CENTER + (postID != undefined ? '?postID=' + postID : ''));
    },
    async CreateCenter(body) {
        return await instance.post(ADD_UPDATE_CENTER, body);
    },
    async DeleteCenter(centerId) {
        return await instance.post(DELETE_CENTER + "?centerId=" + centerId);
    },
    async GetAllClassRoom() {
        return await instance.get(GET_ALL_CLASSROOMS + "?centerId=0");
    },
    async CreateClassRoom(body) {
        return await instance.post(ADD_UPDATE_CLASSROOMS, body);
    },
    async DeleteClassRoom(classRoomId) {
        return await instance.post(DELETE_CLASSROOM + "?classRoomId=" + classRoomId);
    },
    async GetAllSpecialization() {
        return await instance.get(GET_ALL_SPECIFICATIONS);
    },
    async CreateSpecialization(body) {
        return await instance.post(ADD_UPDATE_SPECIFICATION, body);
    },
    async DeleteSpecialization(DegreeId) {
        return await instance.post(DELETE_SPECIFICATION + "?qualificationId=" + DegreeId);
    },
    async GetChallanBankDetailData() {
        return await instance.get(GET_CHALAN_BANK_DETAILS);
    },
    async CreateChallanBankDetail(body) {
        return await instance.post(ADD_CHALAN_BANK_DETAILS, body);
    },
    async DeleteChallanBankDetail(challanBankDetailId) {
        return await instance.post(DELETE_CHALAN_BANK_DETAILS + "?challanBankDetailId=" + challanBankDetailId);
    },
    async GetAllCandidates(pageIndex,pageSize,isAllStudentRegisterData) {
        return await instance.get(`${GET_ALL_STUDENTS}?pageIndex=${pageIndex}&pageSize=${pageSize}&isAllStudentRegisterData=${isAllStudentRegisterData}&searchTerm=&columnName=Gender&orderBy=1`);
    },
    async SearchCandidates(pageIndex, pageSize,isAllStudentRegisterData,searchTerm, txnMatched) {
        return await instance.get(`${GET_ALL_STUDENTS}?strTransaction=${txnMatched}&pageIndex=${pageIndex}&pageSize=${pageSize}&isAllStudentRegisterData=${isAllStudentRegisterData}&searchTerm=${searchTerm}&columnName=Gender&orderBy=1`);
    },
    async GetStudentDataForReview(Application_Id) {
        return await instance.get(GET_ALL_STUDENTS_FOR_REVIEW + "?ApplicationId=" + Application_Id);
    },
    async UpdateStudentApprovedRejectedData(body) {
        return await instance.post(UPDATE_STUDENT_DATA, body);
    },
    async UploadBankTransactions(body) {
        return await instance.post(READ_EXCEL, body);
    },
    async UpdateBulkApprovedOrRejectedStatus(body) {
        return await instance.post(UPDATE_STUDENT_STATUS, body);
    },
    async ExportAllStudentData(AppliedPostId, CategoryId, State, District, Taluka, Name) {
        return await instance.get(`${EXPORT_ALL_STUDENTS}?AppliedPostId=${AppliedPostId}&CategoryId=${CategoryId}&State=${State}&District=${District}&Taluka=${Taluka}&Name=${Name}`);
    },
    async GetAllStudentsAttendanceSheet(postId, is_Approved_Rejected) {
        return await instance.get(`${GET_ALL_STUDENTS_ATTENDANCE}?postId=${postId}&is_Approved_Rejected=${is_Approved_Rejected}`);
    },
    // Recruitment Candidate-List Publication Modernization phase. postId omitted -> all posts.
    async GetEligibleCandidates(postId) {
        return await instance.get(`${GET_ELIGIBLE_CANDIDATES}${postId ? '?postId=' + postId : ''}`);
    },
    GetAttendanceURL(fileName) {
        return `${ROOT_PATH}/${EXPORT_ATTENDANCE_EXCEL}/${fileName}`;
    },
    GetAllStudentURL(fileName) {
        return `${ROOT_PATH}/${EXPORT_RESULT_EXCEL}/${fileName}`;
    },
    async UpdateStudentCenterAndBatch(body) {
        return await instance.post(UPDATE_STUDENT_BATCH, body);
    },
    async RemoveStudentFromCenterAndBatch(body) {
        return await instance.post(REMOVE_STUDENT_FROM_BATCH, body);
    },
    async GetAllStudentByCenterAndBatch(pageSize, pageIndex, searchTerm, params) {
        let searchPattern = "";
        if (params != undefined)
            searchPattern = `Post|${params.Post}|State|${params.State}|District|${params.District}|Taluka|${params.Taluka}`;
        return await instance.get(`${GET_ALL_STUDENTS_BY_CENTER}?strTransaction=${searchPattern}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm == undefined ? "" : searchTerm}&columnName=&orderBy=1`);
    },
    async GetAssignedStudentByCenterAndBatch(pageSize, params) {
        let searchPattern = "";
        if (params != undefined)
            searchPattern = `Post|${params.Post}|State|${params.State}|District|${params.District}|Taluka|${params.Taluka}|CenterID|${params.CenterID}|BatchID|${params.BatchID}`;
        return await instance.get(`${GET_ALL_STUDENTS_BY_CENTER}?strTransaction=${searchPattern}&pageIndex=1&pageSize=${pageSize}&searchTerm=&columnName=&orderBy=1&batchAssigned="assigned"`);
    },
    async GetAllStates(postID) {
        return await instance.get(GET_ALL_STATES + "?postId=" + postID);
    },
    async GetAllDistricts(postID) {
        return await instance.get(GET_ALL_DISTRICT + "?postId=" + postID);
    },
    async GetAllTalukas(postID) {
        return await instance.get(GET_ALL_TALUKAS + "?postId=" + postID);
    },
    async AddUpdateStudentRolleNumber(body) {
        return await instance.post(UPDATE_STUDENT_ROLL_NUMBER, body);
    },
    async GetAllStudentRollNumberData(Post_Id) {
        return await instance.get(GET_ALL_STUDENTS_ROLL_NUMBER + "?applicationPost_Id=" + Post_Id);
    },
    async RegenerateStudentRollNumber(Post_Id) {
        return await instance.get(REGENERATE_STUDENTS_ROLL_NUMBER + "?applicationPost_Id=" + Post_Id);
    },
    async AddNotification(body) {
        return await instance.post(ADD_UPDATE_STUDENT_NOTIFICATION, body);
    },
    async exportBatchData(postId) {
        return await instance.get(EXPORT_ALL_STUDENTS_BATCHES + "?ApplicationPostId=" + postId);
    },
    async exportStudentBatchData(postId) {
        return await instance.get(EXPORT_ALL_STUDENTS_DATA + "?ApplicationPostId=" + postId);
    },
    exportBatchDataToExcel(fileName) {
        return `${ROOT_PATH}/${EXPORT_ALL_STUDENTS_BATCHES_EXCEL}/${fileName}`;
    },
    exportStudentBatchDataToExcel(fileName) {
        return `${ROOT_PATH}/${EXPORT_ALL_STUDENTS_DATA_EXCEL}/${fileName}`;
    },
    async GetAllRazorPayTransactions(params) {
        return await instance.get(`${GET_ALL_RAZORPAY_TRANSACTIONS}?pageIndex=${params.pageIndex}&pageSize=${params.pageSize}&searchTerm=${params.searchTerm}&sortBy=${params.sortBy}&orderBy=${params.orderBy}`);
    },
    async RefundTransaction(razorPayPaymentId) {
        return await instance.post(REFUND_TRANSACTION + "?razorPayPaymentId=" + razorPayPaymentId);
    },
    async GetCaptcha() {
        return await instance.get(`${GET_CAPTCHA}`);
    },
    async ResetDatabase(resetCode) {
        return await instance.get(GET_RESET_DATABASE + "?resetCode=" + resetCode);
    },
    async GetPostConfigurationData(PostID, typeName) {
        return await instance.get(GET_POST_CONFIGURATION_DATA + `?postId=${PostID}&type=${typeName}`);
    },
    async AddUpdatePostConfiguration(body) {
        return await instance.post(ADD_UPDATE_POST_CONFIGURATION, body);
    },
    async GetPhotoSignatureData(appliedPostId, isUserImage) {
        return await instance.get(EXPORT_ALL_IMAGES_DATA + `?appliedPostId=${appliedPostId}&isUserImage=${isUserImage}`);
    },
    async ValidateLicenceKey() {
        return await instance.get(VALIDATE_LICENCE_KEY);
    },
    async ImportStudentResult(body) {
        return await instance.post(IMPORT_STUDENT_RESULT, body);
    },
    async ImportStudentInterviewResult(postId, body) {
        return await instance.post(`${IMPORT_STUDENT_INTERVIEW_RESULT}?postId=${postId}`, body);
    },
    // Primary Result Automation & Interview Shortlisting phase.
    async PreviewInterviewShortlist(postId) {
        return await instance.get(`${PREVIEW_INTERVIEW_SHORTLIST}?postId=${postId}`);
    },
    async ConfirmInterviewShortlist(postId, confirmReplace) {
        return await instance.post(`${CONFIRM_INTERVIEW_SHORTLIST}?postId=${postId}&confirmReplace=${confirmReplace ? 'true' : 'false'}`);
    },
    // Interview Marks Workflow & Final Result Foundation phase.
    async ImportFinalResult(postId, body) {
        return await instance.post(`${IMPORT_FINAL_RESULT}?postId=${postId}`, body);
    },
    async PreviewFinalResult(postId) {
        return await instance.get(`${PREVIEW_FINAL_RESULT}?postId=${postId}`);
    },
    async PublishFinalResult(postId, confirmReplace) {
        return await instance.post(`${PUBLISH_FINAL_RESULT}?postId=${postId}&confirmReplace=${confirmReplace ? 'true' : 'false'}`);
    },
    // Final Result, Selected/Waiting Publication & Appointment Letter Closure phase.
    async GetPublishedSelectedWaitingRollNumbers(postId) {
        return await instance.get(`${GET_PUBLISHED_SELECTED_WAITING_ROLL_NUMBERS}?postId=${postId}`);
    },
    async ExportInterviewBlindData(postId) {
        return await instance.get(`${EXPORT_INTERVIEW_BLIND_DATA}?postId=${postId}`, { responseType: 'blob' });
    },
    async GetStudentResultByApplicationId(){
        return await instance.get(GET_STUDENT_RESULT_BY_APPLICATION_ID);
    },
    async GetAllStudentAnswerPaperList() {
        return await instance.get(GET_ALL_STUDENT_ANSWER_PAPER_LIST);
    },
    async AddOrUpdateStudentAnswerPaper(body) {
        return await instance.post(Add_Or_Update_Student_Answer_Paper, body);
    },
    async DeleteStudentAnswerPaper(studentAnswerPaperId) {
        return await instance.post(DELETE_STUDENT_ANSWER_PAPER + "?studentAnswerPaperId=" + studentAnswerPaperId);
    },

    async SendBulkHallTicketSMS() {
        return await instance.get(SEND_BULK_SMS_FOR_HALL_TICKET_DOWNLOAD);
    },
    async GetStudentListForRetryHallTicketSMS() {
        return await instance.get(GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_SMS);
    },
    async SendRetrySMSForHallTicketDownload(id) {
        return await instance.get(SEND_RETRY_SMS_FOR_HALL_TICKET_DOWNLOAD + `?studentId=${id}`);
    },

    async SendBulkHallTicketEmail() {
        return await instance.get(SEND_BULK_EMAIL_FOR_HALL_TICKET_DOWNLOAD);
    },
    async GetStudentListForRetryHallTicketEmail() {
        return await instance.get(GET_STUDENT_LIST_FOR_RETRY_HALL_TICKET_EMAIL);
    },
    async SendRetryEmailForHallTicketDownload(id) {
        return await instance.get(SEND_RETRY_EMAIL_FOR_HALL_TICKET_DOWNLOAD + `?studentId=${id}`);
    },

    async SendBulkSMSForInterviewCallLetterDownload(){
        return await instance.get(SEND_BULK_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD);
    },
    async GetStudentListForRetryInterviewCallLetterSMS() {
        return await instance.get(GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_SMS);
    },
    async SendRetrySMSForInterviewCallLetterDownload(id) {
        return await instance.get(SEND_RETRY_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD + `?studentId=${id}`);
    },

    async SendBulkEmailForInterviewCallLetterDownload(){
        return await instance.get(SEND_BULK_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD);
    },
    async GetStudentListForRetryInterviewCallLetterEmail() {
        return await instance.get(GET_STUDENT_LIST_FOR_RETRY_INTERVIEW_CALL_LETTER_EMAIL);
    },
    
     async GetStudentDataForAdmin(applicationId, roleNumber) {
        return await instance.get(GET_STUDENT_DATA_FOR_ADMIN + `?applicationId=${applicationId}&roleNumber=${roleNumber}`);
    },
    async GetStudentReceiptDataForAdmin(applicationId, roleNumber) {
        return await instance.get(GET_STUDENT_RECEIPT_DATA_FOR_ADMIN + `?applicationId=${applicationId}&roleNumber=${roleNumber}`);
    },

    async SendBulkSMSForViewResultSMS(){
        return await instance.get(SEND_BULK_SMS_FOR_VIEW_RESULT_SMS);
    },
    async SendBulkEmailForViewResultEmail(){
        return await instance.get(SEND_BULK_EMAIL_FOR_VIEW_RESULT);
    },
    async SendRetryEmailForInterviewCallLetterDownload(id) {
        return await instance.get(SEND_RETRY_EMAIL_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD + `?studentId=${id}`);
    },
   async SendRetrySMSForInterviewCallLetterDownload(id) {
        return await instance.get(SEND_RETRY_SMS_FOR_INTERVIEW_CALL_LETTER_DOWNLOAD + `?studentId=${id}`);
    },
 
    async GetStudentDataForAttendance(minRollNumber, maxRollNumber) {
        return await instance.get(`${GET_STUDENT_DATA_FOR_ATTENDANCE}?startRoleNumebr=${minRollNumber}&endRoleNumber=${maxRollNumber}`);
    },
    async ImportAttendance(body) {
        return await instance.post(IMPORT_STUDENT_ATTENDANCE_DATA, body);
    },
    async GetAllCenterList() {
        return await instance.get(GET_ALL_CENTER_LIST);
    },
    async GetAllBatchCenterByName(centerName) {
        return await instance.get(`${GET_ALL_BATCH_CENTER_BY_NAME}?center=${centerName}`);
    },
    async GetAllAttendanceData(centerName, batchName, post) {
        return await instance.post(`${GET_ALL_ATTENDANCE_DATA}?center=${centerName}&batchName=${batchName}&post=${post}`);
    },
    async DeleteStudentAttendanceData() {
        return await instance.get(DELETE_STUDENT_ATTENDANCE_DATA);
    },
    async GetTotalStudentRegisterData() {
        return await instance.get(GET_TOTAL_STUDENT_REGISTER_DATA);
    },
    async GetDistinctPostByCenterAndBatch(centerName, batchName) {
        return await instance.get(`${GET_DISTINCT_POST_BY_CENTER_AND_BATCH}?center=${centerName}&batchName=${batchName}`);
    },
    

    async GetAllStudentAakshepData() {
        return await instance.get(GET_ALL_STUDENT_AKSHEP_DATA);
    },
    async DeleteStudentAakshepData(studentAakshepDataId) {
        return await instance.post(`${DELETE_STUDENT_AKSHEP_DATA}?studentAakshepDataId=${studentAakshepDataId}`);
    },
    async AddOrUpdateStudentAakshepData(body) {
        return await instance.post(ADD_UPDATE_STUDENT_AKSHEP_DATA, body);
    },
    async GetStudentAakshepData(studentAakshepDataId) {
        return await instance.get(`${GET_STUDENT_AKSHEP_DATA}?studentAakshepDataId=${studentAakshepDataId}`);
    },

    async ImportCenterBatchData(body) {
        return await instance.post(IMPORT_CENTER_BATCH_DATA, body);
    },
    async GetAllCenterBatchList() {
        return await instance.get(GET_ALL_CENTER_BATCH_LIST);
    },
    async GetAllCenterBatchDataByCenter(centerName) {
        return await instance.get(`${GET_ALL_CENTER_BATCH_DATA_BY_CENTER}?center=${centerName}`);
    },
    async DeleteCenterBatchData() {
        return await instance.get(DELETE_CENTER_BATCH_DATA);
    },
    async ImportCenterBatchLabCountData(body) {
        return await instance.post(IMPORT_CENTER_BATCH_LAB_COUNT_DATA, body);
    },
    async DeleteCenterBatchLabCountData() {
        return await instance.get(DELETE_CENTER_BATCH_LAB_COUNT_DATA);
    },
    async GetDistinctCenterFromBatchLabCount() {
        return await instance.get(`${GET_DISTINCT_CENTER_FROM_BATCH_LAB_COUNT}`);
    },
    async GetDistinctExamDateByCenterName(centerName) {
        return await instance.get(`${GET_DISTINCT_EXAM_DATE_BY_CENTER_NAME}?Center=${centerName}`);
    },
    async GetAllCenterBatchLabCountDataByCenterAndDate(centerName, examDate) {
        return await instance.get(`${GET_ALL_CENTER_BATCH_LAB_COUNT_DATA_BY_CENTER_AND_DATE}?center=${centerName}&examdate=${examDate}`);
    },
    async ExportCenterWiseAttendanceData(centerName) {
        return await instance.get(`${EXPORT_CENTER_WISE_ATTENDANCE_DATA}?Center=${centerName}`);
    },
    
    async ImportStudentInterviewTimeData(body) {
        return await instance.post(IMPORT_STUDENT_INTERVIEW_TIME_DATA, body);
    },
    async GetDistinctPostFromStudentInterviewTimeData() {
        return await instance.get(GET_DISTINCT_POST_FROM_STUDENT_INTERVIEW_TIME_DATA);
    },
    async GetAllStudentInterviewTimeDataByPost(post) {
        return await instance.get(`${GET_ALL_STUDENT_INTERVIEW_TIME_DATA_BY_POST}?post=${post}`);
    },
    async DeleteStudentInterviewTimeData() {
        return await instance.get(DELETE_STUDENT_INTERVIEW_TIME_DATA);
    },
    async getStudentInterviewTimeDateByApplicationID() {
        return await instance.get(GET_STUDENT_INTERVIEW_TIME_DATE_BY_APPLICATION_ID);
    },
    

    async ImportStudentAppointmentData(body) {
        return await instance.post(IMPORT_STUDENT_APPOINTMENT_DATA, body);
    },
    async GetDistinctPostFromStudentAppointmentData() {
        return await instance.get(GET_DISTINCT_POST_FROM_STUDENT_APPOINTMENT_DATA);
    },
    async GetAllStudentAppointmentDataByPost(post) {
        return await instance.get(`${GET_ALL_STUDENT_APPOINTMENT_DATA_BY_POST}?post=${post}`);
    },
    async DeleteStudentAppointmentData() {
        return await instance.get(DELETE_STUDENT_APPOINTMENT_DATA);
    },
    async getStudentAppointmentDataByRoleNumber() {
        return await instance.get(GET_STUDENT_APPOINTMENT_DATA_BY_ROLE_NUMBER);
    },


    async GenerateLicenseKey(body) {
        return await instance.post(GENERATE_LICENSE_KEY, body);
    },

    //Aadhar Verification api
    async GetAadharLogDataCountByPostAndAadharNumber(post_Id,aadharNumber) {
        return await instance.post(`${GET_AADHAR_LOG_DATA_COUNT_BY_POST_AND_AADHAR_NUMBER}?Post_Id=${post_Id}&aadharNumber=${aadharNumber}`);
    },
    async AddOrUpdateStudentAadharLog(body) {
        return await instance.post(ADD_OR_UPDATE_STUDENT_AADHAR_LOG, body);
    }
    

    
}

export default _AdminService;